import type { I18n } from '../types';

export enum LoadingErrorType {
  Network = 'NETWORK',
  Unknown = 'UNKNOWN',
}

export interface ScreenError {
  type: LoadingErrorType;
  name: string;
  message: string;
}

export interface ErrorScreenProps {
  error: ScreenError;
  translations: I18n;
  biLogger: {
    report: (reportProps: any) => Promise<any>;
  };
}
